var _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgTask = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/task"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/task_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "task"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21 20.25H11C10.59 20.25 10.25 19.91 10.25 19.5C10.25 19.09 10.59 18.75 11 18.75H21C21.41 18.75 21.75 19.09 21.75 19.5C21.75 19.91 21.41 20.25 21 20.25Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21 13.25H11C10.59 13.25 10.25 12.91 10.25 12.5C10.25 12.09 10.59 11.75 11 11.75H21C21.41 11.75 21.75 12.09 21.75 12.5C21.75 12.91 21.41 13.25 21 13.25Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21 6.25H11C10.59 6.25 10.25 5.91 10.25 5.5C10.25 5.09 10.59 4.75 11 4.75H21C21.41 4.75 21.75 5.09 21.75 5.5C21.75 5.91 21.41 6.25 21 6.25Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.99994 7.24945C3.80994 7.24945 3.61994 7.17945 3.46994 7.02945L2.46994 6.02945C2.17994 5.73945 2.17994 5.25945 2.46994 4.96945C2.75994 4.67945 3.23994 4.67945 3.52994 4.96945L3.99994 5.43945L6.46994 2.96945C6.75994 2.67945 7.23994 2.67945 7.52994 2.96945C7.81994 3.25945 7.81994 3.73945 7.52994 4.02945L4.52994 7.02945C4.37994 7.17945 4.18994 7.24945 3.99994 7.24945Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M3.99994 14.2495C3.80994 14.2495 3.61994 14.1795 3.46994 14.0295L2.46994 13.0295C2.17994 12.7395 2.17994 12.2595 2.46994 11.9695C2.75994 11.6795 3.23994 11.6795 3.52994 11.9695L3.99994 12.4395L6.46994 9.96945C6.75994 9.67945 7.23994 9.67945 7.52994 9.96945C7.81994 10.2595 7.81994 10.7395 7.52994 11.0295L4.52994 14.0295C4.37994 14.1795 4.18994 14.2495 3.99994 14.2495Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M3.99994 21.2495C3.80994 21.2495 3.61994 21.1795 3.46994 21.0295L2.46994 20.0295C2.17994 19.7395 2.17994 19.2595 2.46994 18.9695C2.75994 18.6795 3.23994 18.6795 3.52994 18.9695L3.99994 19.4395L6.46994 16.9695C6.75994 16.6795 7.23994 16.6795 7.52994 16.9695C7.81994 17.2595 7.81994 17.7395 7.52994 18.0295L4.52994 21.0295C4.37994 21.1795 4.18994 21.2495 3.99994 21.2495Z",
    fill: "#757575"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTask, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/task.83fe1664.svg";
export { ForwardRef as ReactComponent };